const Colors = {
  primary: "#0EA5EA",
  secondary: "#0BD1D1",
  backgroundColor1: "#0F172A",
  backgroundColor2: "#0C1427",
  white: "#FFFFFF",
  black: "#000000",
  textColor1: "#B9E0F2",
  textColor2: "#7F92B0",
  dashboardBgColor: "#F7FAFC",
  grey: "#A0AEC0",
}

export default Colors;